function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import Reviews from "segments/desktop/core-components/reviews/reviews";
import ReviewCardDefaultProps from "segments/desktop/core-components/review-card/default-props";
import { StyledRegularReviewsComponent } from "./regular-reviews-component.scss";
class RegularReviewsComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledRegularReviewsComponent, {
            className: "regular-reviews-component",
            children: /*#__PURE__*/ _jsx(Reviews, _object_spread({}, this.props))
        });
    }
}
export { RegularReviewsComponent as default };
RegularReviewsComponent.defaultProps = {
    reviews: Reviews.defaultProps.reviews,
    paddingTop: "92px",
    paddingBottom: "92px",
    cardFontSize: ReviewCardDefaultProps.fontSize,
    reviewCardOverrideHeight: null
};
